// -------------------------------------------------------------------- constants --------------------------------------------------------------------

// *************************************************************** user *****************************************************************
const GET_USER_PERMISSION_TINY_SUCCESS = 'GET_USER_PERMISSION_TINY_SUCCESS';
const UPDATE_USER_PERMISSION_TINY_SUCCESS = 'UPDATE_USER_PERMISSION_TINY_SUCCESS';


// ----------------------------------------------------------------< action creators >----------------------------------------------------------------

// *************************************************************** user *****************************************************************

/**
 *
 * @param {{data: Object}} payload
 * @return {{type: String, payload: Object}}
 * @private
 */
function _getPermissionSuccess(payload) {
  return {
    type: GET_USER_PERMISSION_TINY_SUCCESS,
    payload: payload,
  };
}

/**
 *
 * @param {{data: Object}} payload
 * @return {{type: String, payload: Object}}
 * @private
 */
function _setPermissionSuccess(payload) {
  return {
    type: UPDATE_USER_PERMISSION_TINY_SUCCESS,
    payload: payload.data,
  };
}

// --------------------------------------------------------------------< actions >--------------------------------------------------------------------

// *************************************************************** user *****************************************************************

/**
 *
 * @param {Number} user
 * @param {Object} [params={}]
 * @param {Function} [callback=(function())]
 * @return {Function}
 */
export function getPermission(user, params = {}, callback = () => {
}) {
  return (dispatch, gs, api) => {
    if (app.can('UserPermissions@index')) {

      api.get(`/user/${user}/permissions`, {params})
        .then((res) => {
          dispatch(_getPermissionSuccess(res));
          callback(undefined, res);
        })
        .catch((err) => {
          callback(err);
        });
    } else {
      callback(undefined);
      app.message(
        app.translate(
          'routes.permission error',
          {
            permission: `${app.translate('routes.home.basic.permission.UserPermissions', 'UserPermissions')} - ${app.translate('routes.home.basic.permission.index', 'index')}`,
          },
          'permission error',
        ), 'error');
    }
  };
}

/**
 *
 * @param {Number} user
 * @param {Object} data
 * @param {Object} [params={}]
 * @param {Function} [callback=(function())]
 * @return {Function}
 */
export function setPermission(user, data, params = {}, callback = () => {
}) {
  return (dispatch, gs, api) => {
    if (app.can('UserPermissions@update')) {
      let loader = app.loading(app.translate('routes.home.basic.permission.Assigning Permissions'));

      api.put(`/user/${user}/permissions`, {
        data: {permissionUser: data}, params,
      })
        .then((res) => {
          dispatch(_setPermissionSuccess(res));
          loader.hide(() => app.message(app.translate('routes.home.basic.permission.Permissions Assigned Successfully')));
          callback(undefined, res);
        })
        .catch((err) => {
          loader.hide(() => app.error(
            err, 'routes.home.basic.permission.', 'عملیات بروزرسانی با شکست مواجه شد',
            app.translate('routes.home.basic.permission.Permissions Assignment Failed'),
          ));
          callback(err);
        });
    } else {
      callback(undefined);
      app.message(
        app.translate(
          'routes.permission error',
          {
            permission: `${app.translate('routes.home.basic.permission.UserPermissions', 'UserPermissions')} - ${app.translate('routes.home.basic.permission.update', 'update')}`,
          },
          'permission error',
        ), 'error');
    }
  };
}

export function emptyPermission() {
  return _getPermissionSuccess({data: []});
}

// --------------------------------------------------------------------< reducer >--------------------------------------------------------------------
/**
 *
 * @param {Object} state
 * @param {{type: String, payload: Object}} action
 * @return {Object}
 */
export default function reducer(state = {
  permissionsUser: [],
  meta: {},
}, action) {
  switch (action.type) {
    case GET_USER_PERMISSION_TINY_SUCCESS:
      return Object.assign({}, state, {
        permissionsUser: action.payload.data,
      });
    default:
      return state;
  }
}
